"use client";

import React from "react";
import { Twitter, Linkedin, MessageSquare } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const services = ["Latest News", "Expert Guides", "Love & Wellness", "Zodiac Insights"];
  const contactInfo = ["hello@sexpleasure.store", "Editorial Office", "New York, NY"];
  return <div className="col-span-1 md:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-8">
      {}
      <div className="flex flex-col gap-4">
        <h4 className="font-default text-foreground font-semibold tracking-tight">Navigation</h4>
        {loading ? <div className="flex flex-col gap-3">
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
            <div className="h-4 w-32 bg-muted animate-pulse rounded-md" />
            <div className="h-4 w-20 bg-muted animate-pulse rounded-md" />
          </div> : <ul className="flex flex-col gap-3">
            {menuItems.map((item, i) => <li key={item.id} data-index={i}>
                <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
                  {item.label}
                </Link>
              </li>)}
          </ul>}
      </div>

      {}
      <div className="flex flex-col gap-4">
        <h4 className="font-default text-foreground font-semibold tracking-tight">Categories</h4>
        <ul className="flex flex-col gap-3">
          {services.map((service, i) => <li key={i} data-index={i}>
              <span className="text-muted-foreground text-sm hover:text-foreground transition-colors cursor-default font-default">
                {service}
              </span>
            </li>)}
        </ul>
      </div>

      {}
      <div className="flex flex-col gap-4">
        <h4 className="font-default text-foreground font-semibold tracking-tight">Connect</h4>
        <ul className="flex flex-col gap-3">
          {contactInfo.map((info, i) => <li key={i} data-index={i}>
              <span className="text-muted-foreground text-sm hover:text-foreground transition-colors cursor-default font-default">
                {info}
              </span>
            </li>)}
        </ul>
      </div>
    </div>;
}
export default function Footer() {
  return <section data-section-id="233523" id="footer" className="bg-background text-foreground py-16 px-6 md:px-12 relative overflow-hidden border-t border-border">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {}
          <div className="col-span-1 flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654438/img/editorial_logo.png" alt="sexpleasure.store Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs font-default">
              A clean, editorial space dedicated to wellness, love, and modern guides for a more fulfilling lifestyle.
            </p>
          </div>

          {}
          <MenuProvider menu_id="48">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-border to-transparent mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-muted-foreground order-3 md:order-1 font-default">
            © {new Date().getFullYear()} sexpleasure.store. All rights reserved.
          </p>
          
          <div className="flex items-center gap-6 order-2">
            <Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors font-default">
              Privacy Policy
            </Link>
            <Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors font-default">
              Terms of Service
            </Link>
          </div>

          <div className="flex items-center gap-3 order-1 md:order-3">
            <Button variant="outline" size="icon" className="rounded-full border-border/50 hover:border-primary hover:text-primary hover:bg-primary/5 bg-transparent text-muted-foreground transition-all" asChild>
              <Link to="#" aria-label="Discord">
                <MessageSquare className="size-4" />
              </Link>
            </Button>
            <Button variant="outline" size="icon" className="rounded-full border-border/50 hover:border-primary hover:text-primary hover:bg-primary/5 bg-transparent text-muted-foreground transition-all" asChild>
              <Link to="#" aria-label="X (Twitter)">
                <Twitter className="size-4" />
              </Link>
            </Button>
            <Button variant="outline" size="icon" className="rounded-full border-border/50 hover:border-primary hover:text-primary hover:bg-primary/5 bg-transparent text-muted-foreground transition-all" asChild>
              <Link to="#" aria-label="LinkedIn">
                <Linkedin className="size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}